import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Switch from '@mui/material/Switch';
import TablePagination from '@mui/material/TablePagination';
import FormControlLabel from '@mui/material/FormControlLabel';

// ----------------------------------------------------------------------

export default function TablePaginationCustom({
  dense,
  onChangeDense,
  rowsPerPageOptions = [5, 10, 25],
  page,
  rowsPerPage,
  count,
  onPageChange,
  onRowsPerPageChange,
  sx,
}) {
  return (
    <Box sx={{ position: 'relative', ...sx }}>
      <TablePagination
        component="div"
        count={count}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
        rowsPerPageOptions={rowsPerPageOptions}
        labelRowsPerPage="Registros por página:"
        labelDisplayedRows={({ from, to, count: total }) =>
          `${from}-${to} de ${total !== -1 ? total : `más de ${to}`}`
        }
      />

      {typeof onChangeDense === 'function' && (
        <FormControlLabel
          label="Comprimir"
          control={
            <Switch
              checked={dense}
              onChange={(e) => onChangeDense(e.target.checked)}
            />
          }
          sx={{
            pl: 2,
            py: 1.5,
            top: 0,
            position: {
              sm: 'absolute',
            },
          }}
        />
      )}
    </Box>
  );
}

TablePaginationCustom.propTypes = {
  dense: PropTypes.bool.isRequired,
  onChangeDense: PropTypes.func,
  rowsPerPageOptions: PropTypes.arrayOf(PropTypes.number),
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onRowsPerPageChange: PropTypes.func.isRequired,
  sx: PropTypes.object,
};
